/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const PlusCircle = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M10 2c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4.6 8.9c0 .2-.2.4-.4.4h-3v3c0 .2-.2.4-.4.4H9.1c-.2 0-.4-.2-.4-.4v-3h-3c-.2 0-.4-.2-.4-.4V9.1c0-.2.2-.4.4-.4h3v-3c0-.2.2-.4.4-.4h1.8c.2 0 .4.2.4.4v3h3c.2 0 .4.2.4.4v1.8z" />
  </svg>
);

export default extendIcon(PlusCircle);
